<!--设备本地日志-->
<template>
  <div class="local-device-logs">
    <el-form :inline="true" class="search-form">
      <el-form-item label="起始时间">
        <el-date-picker
          v-model="form.startDateTime"
          type="datetime"
          placeholder="开始时间"
          format="yyyy/MM/dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :disabled-date="disabledStartDate"
          :disabled-time="disabledStartTime"
          :clearable="false"
        />
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="form.endDateTime"
          type="datetime"
          placeholder="结束时间"
          format="yyyy/MM/dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :disabled-date="disabledEndDate"
          :disabled-time="disabledEndTime"
          :clearable="false"
        />
      </el-form-item>
      <el-form-item class="button-group">
        <div class="flex-container">
          <el-button type="primary" size="14" @click="handleStartCollect">启动收集</el-button>
          <el-button type="primary" size="14" @click="handleStopCollect">停止收集</el-button>
          <el-button type="primary" size="14" @click="queryList">查询</el-button>
        </div>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="80" />
      <el-table-column prop="name" label="时间(GMT+8)" />
      <el-table-column prop="username" label="协议类型" />
      <el-table-column prop="roleName" label="事件名称" />
      <el-table-column prop="username" label="事件详情" />
      <el-table-column prop="roleName" label="事件来源" />
    </el-table>

    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import { localLogs, startCollect, stopCollect } from '@/api/device/log2'
import dayjs from 'dayjs'
import minMax from 'dayjs/plugin/minMax'
dayjs.extend(minMax)

export default {
  name: 'LocalDeviceLogs',
  props: {
    exist: {
      type: Boolean,
      default: false
    },
    deviceIdOrUid: {
      type: String,
      default: ''
    },
    deviceId: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    },
    queryInfo: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    const now = dayjs()
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 100,
      loading: false,
      form: {
        endDateTime: now.format('YYYY-MM-DD HH:mm'),
        startDateTime: now.subtract(12, 'hour').format('YYYY-MM-DD HH:mm')
      }
    }
  },
  watch: {
    'form.endDateTime'(val) {
      const end = dayjs(val)
      const todayEnd = dayjs().endOf('day')
      if (end.isAfter(todayEnd)) {
        this.form.endDateTime = todayEnd.format('YYYY-MM-DD HH:mm')
      }
      const start = dayjs(this.form.startDateTime)
      if (start.isAfter(end) || start.isBefore(end.subtract(3, 'day'))) {
        this.form.startDateTime = end.subtract(12, 'hour').format('YYYY-MM-DD HH:mm')
      }
    },
    'form.startDateTime'(val) {
      const start = dayjs(val)
      const end = dayjs(this.form.endDateTime)
      const maxEnd = dayjs.min(start.add(3, 'day'), dayjs().endOf('day'))
      if (end.isBefore(start) || end.isAfter(maxEnd)) {
        this.form.endDateTime = start.add(12, 'hour').format('YYYY-MM-DD HH:mm')
      }
    }
  },
  methods: {
    async localLogsList() {
      this.loading = true
      const params = {
        current: this.currentPage,
        size: this.pageSize,
        deviceId: this.deviceId,
        logType: this.deviceType === '1' ? 'device-log' : 'device-gateway-log',
        startDateTime: this.form.startDateTime + ':00',
        endDateTime: this.form.endDateTime + ':59'
      }

      localLogs(params).then(res => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    // 查询
    queryList() {
      this.currentPage = 1 // 重置为第一页
      this.queryInfo() // 调用父组件查询方法
    },
    // 启动收集
    handleStartCollect() {
      startCollect({ deviceId: this.deviceIdOrUid }).then(res => {
        // 成功提示
        this.$message.success('启动收集成功')
      }).catch(err => {
        // 错误提示
        this.$message.error(err.message || '启动收集失败')
      })
    },
    // 停止收集
    handleStopCollect() {
      stopCollect({ deviceId: this.deviceIdOrUid }).then(res => {
        // 成功提示
        this.$message.success('停止收集成功')
      }).catch(err => {
        // 错误提示
        this.$message.error(err.message || '停止收集失败')
      })
    },
    updatePage(page) {
      this.currentPage = page
      this.loadList()
    },
    updateSize(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadList()
    },
    disabledStartDate(date) {
      const end = dayjs(this.form.endDateTime)
      const todayEnd = dayjs().endOf('day')
      return (
        date.getTime() < end.subtract(3, 'day').toDate().getTime() ||
        date.getTime() > end.toDate().getTime() ||
        date.getTime() > todayEnd.toDate().getTime()
      )
    },
    disabledEndDate(date) {
      const start = dayjs(this.form.startDateTime)
      const todayEnd = dayjs().endOf('day')
      return (
        date.getTime() < start.toDate().getTime() ||
        date.getTime() > start.add(3, 'day').toDate().getTime() ||
        date.getTime() > todayEnd.toDate().getTime()
      )
    },
    disabledStartTime() {
      const end = dayjs(this.form.endDateTime)
      const min = end.subtract(3, 'day')
      const max = end
      return this.getDisabledTimeRange(min, max)
    },
    disabledEndTime() {
      const start = dayjs(this.form.startDateTime)
      const max = dayjs().endOf('day')
      const min = start
      const maxLimit = dayjs.min(start.add(3, 'day'), max)
      return this.getDisabledTimeRange(min, maxLimit)
    },
    getDisabledTimeRange(min, max) {
      return {
        disabledHours: () => {
          const hours = []
          for (let i = 0; i < 24; i++) {
            const t = dayjs().hour(i).minute(0)
            if (t.isBefore(min, 'hour') || t.isAfter(max, 'hour')) {
              hours.push(i)
            }
          }
          return hours
        },
        disabledMinutes: (hour) => {
          const minutes = []
          for (let m = 0; m < 60; m++) {
            const t = dayjs().hour(hour).minute(m)
            if (t.isBefore(min, 'minute') || t.isAfter(max, 'minute')) {
              minutes.push(m)
            }
          }
          return minutes
        }
      }
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.pageSize = val
      this.localLogsList()
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.currentPage = val
      this.localLogsList()
    }
  }
}
</script>

<style scoped lang="scss">
.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.button-group {
  margin-left: auto !important;
  min-width: max-content;
}
</style>
